<template>
  <div class="slide_data">
     <div class="personal-bottom-bottom-left">
       <div @click="navpublicvideo" class="publicvideos">
         <span>发布</span>
       </div>
          <slide @change="change" :slideItem='slideItem'></slide>
        </div>
  </div>

</template>
<script>
import slide from '../../component/template_slide.vue';
  import {
    getUserInfo,
  } from '@/api/video.js'
export default {
  components:{
    slide
  },
  async created() {
    // 用户信息
    let userInfo = await getUserInfo({})
    if(userInfo.data && userInfo.data.code == 200){
      this.userInfo = userInfo.data.data;
      console.log('用户信息',this.userInfo);
    }
  },
  inject:['reload'],
    data(){
        return {
          userInfo:{},
          slideItem:[
            {
              title: '首页',
              image: 'guanzhu',
              path: '/centerContent',
              serve: []
            },
           {
             title: '内容管理',
             image: 'tuidan',
             path: '/videomanagement',
             serve: [{
               title1: "视频管理",
               path: '/videomanagement', // 默认显示第一个
             }, {
               title1: "草稿箱",
               path: '/centerfraft', // 默认显示第一个
             }]
           },
           {
             title: '互动管理',
             image: 'tuidan',
             path: '/contentreview',
             serve: [{
               title1: "评论管理",
               path: '/contentreview', // 默认显示第一个
             }]
           },
          ]
        }
    },
    methods:{
      refresh(){
        this.reload();
        console.log('刷新了');
      },
      ruleUser(){
        if(!localStorage.getItem("token")){
          this.$message.error('请登录后操作');
          this.$router.replace({
            path:'/',
            query:{
              login:1
            }
          })
          return false
        }
        if(this.userInfo.userInfo.identity == 1){
          this.$message.error('认证主播后可以发布短视频！')
          return false
        }

        return true
      },
      navpublicvideo(){

        let state = this.ruleUser();
        if(state){
          this.$emit('stachange',{
            path:'/centeraddVideo',
            query:{id: '10', tab: '0', statusvideo:'add',pagestatus: '/centeraddVideo'}
          })
        }

      },
      change(e){

        let state = this.ruleUser();
        if(state){
          this.$emit('stachange',e)
        }

      }
    }
}
</script>
<style lang="scss" scoped>
  .slide_data{
    min-height: calc(98vh - 100px);
    background-color: #fff;
  }
  .personal-bottom-bottom-left {
    width: 190px;
    margin-top: 16px;
    color: #333;
    .publicvideos{
      margin: 20px 0;
     display:flex;
     justify-content: center;
      cursor: pointer;
      span{
        width: 142px;
        height: 44px;
        text-align: center;
        line-height: 44px;
        background: #721EDC;
        border-radius: 4px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
      }
    }

    .myel-collapse-item {
      width: 190px;
    }

    .prent_item {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      transition: all 1.2s;
      padding: 0 24px;

      .parent_icon {
        display: flex;
        align-items: center;
        margin-right: 4px;
        width: 18px;
        height: 18px;

        img {
          width: 18px;
          height: 18px;
        }
      }

      .actives {
        color: #721edc !important;
        font-size: 15px !important;
      }

      .parent_name {
        display: flex;
        transition: all 0.2s;
        align-items: center;
        font-size: 14px;
      }
    }

    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;

      .child_img {
        display: flex;
        align-items: center;
      }

      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
      }
    }
  }

  .personal-bottom-bottom-left .el-collapse-item__header {
    box-sizing: border-box;
    padding-left: 20px;
    background-color: #fff;
    border-bottom: 0px solid #ebeef5;
    color: #333;
  }

  .personal-bottom-bottom-left .is-active {
    color: inherit;
  }

  .personal-bottom-bottom-left .el-collapse-item__content {
    padding-bottom: 0px;
  }

  .personal-bottom-bottom-left .el-collapse-item__wrap {
    border-bottom: 1px solid #ebeef5 !important;
  }

  .personal-bottom-bottom-left .el-collapse-item__content>div {
    text-align: center;
  }

  .personal-bottom-bottom-left .el-collapse {
    border-top: 0px solid #ebeef5;
    width: 100%;
  }

  .personal-bottom-bottom-left .el-collapse-item__wrap {
    /* background-color: black; */
    color: #333;
  }

</style>



// WEBPACK FOOTER //
// src/pages/template/centerAside.vue